import Immutable, { Map } from 'immutable';

import {
  FETCH_KET_EXAMS_PLAN_REQUEST,
  FETCH_KET_EXAMS_PLAN_SUCCESS,
  FETCH_KET_EXAMS_PLAN_FAILURE,
  FETCH_KET_EXAM_REQUEST,
  FETCH_KET_EXAM_SUCCESS,
  FETCH_KET_EXAM_FAILURE,
} from './actions';
import KetExam from './model';

import { ApiResponseHelper } from 'omni-common-ui';

const initialState = new Map({
  plans: new Map(), // key: groupId
  exams: new Map(), // key: ketExamId
});

export default function ketExams(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_KET_EXAMS_PLAN_REQUEST:
      return state.setIn(['plans', action.groupId], ApiResponseHelper.create({
        loading: true,
      }));
    case FETCH_KET_EXAMS_PLAN_SUCCESS:
      return state.setIn(['plans', action.groupId], ApiResponseHelper.create(
        Immutable.fromJS((action.payload || []).map((exam) => ({
          ...exam,
          ketExamId: `${exam.ketExamId}`,
        })))));
    case FETCH_KET_EXAMS_PLAN_FAILURE:
      return state.setIn(['plans', action.groupId], ApiResponseHelper.create(action.error));
    case FETCH_KET_EXAM_REQUEST:
      return state.setIn(['exams', action.ketExamId], ApiResponseHelper.create({
        loading: true,
      }));
    case FETCH_KET_EXAM_SUCCESS:
      return state.setIn(['exams', action.ketExamId], ApiResponseHelper.create(
        KetExam.create(Object.assign({}, action.payload, {
          ketExamId: action.ketExamId,
          groupId: action.groupId,
        }))));
    case FETCH_KET_EXAM_FAILURE:
      return state.setIn(['exams', action.ketExamId], ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/KetExams/reducer.js